import {profileConstants } from "../constants/profile.constants";
export const updateSelectedVal = (item) => dispatch => {
	 dispatch({
        type: profileConstants.UPDATE_SELECTED_USER_PROFILE ,
        updatedValAction: item
    });
}